module.exports = __webpack_public_path__ + "static/media/icon-court-reserved.7962eadc.svg";